import React, { useState, useEffect } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";
import { withStyleProps } from "Utils/styleProps";

import makeBem from "Utils/makeBem";

const bem = makeBem("Toggle");

let Toggle = ({ size = "small", onToggle, toggleState, labelText, id }) => {
  const [toggle, setToggle] = useState(toggleState || false);
  // Use toggleState if we need to set the toggle on or off based on external logic
  useEffect(() => setToggle(toggleState), [toggleState]);

  const handleClick = () => {
    const newState = !toggle;
    setToggle(newState);
    onToggle && onToggle(newState);
  };

  return (
    <div className={classnames(bem(), `Toggle--${size}`)}>
      <input type="checkbox" checked={toggle} onChange={handleClick} id={id} name="toggle" />
      <label htmlFor={id}>
        <span className={classnames(bem("slider"), bem("slider", size))} />
        {labelText}
      </label>
    </div>
  );
};

Toggle.propTypes = {
  size: PropTypes.oneOf(["small", "large"]),
  onToggle: PropTypes.func,
};
Toggle = withStyleProps(Toggle);
export default Toggle;
